import React from 'react';
import {useState, useEffect} from 'react';
import { Input, Card, Button,CardBody,CardHeader,CardText, CardTitle, CardFooter, Container } from 'reactstrap';
import Swal from 'sweetalert2'
import { AppContext } from './AppContext';

export const CalculaIntereses = (props) => {
    let meses = ["Agosto","Septiembre"];
    let [totales, setTotales] = useState([0,0]);
    let [total, setTotal] = useState(0);
    function actualiza(i,valor){
      totales[i] = valor;
      total = totales[0] + totales[1];
      setTotal(total);
      props.actualiza(total)
    }
    return(
      <Container>
        <div className='row' style={{padding:10}}>
          <h6>TOTAL <b>{total.toFixed(2)}</b></h6>
          {meses.map((o,i)=> <CalculaInteresesOrdinario mes={o} indice={i} actualiza={actualiza} />)}
          <h6>TOTAL <b>{total.toFixed(2)}</b></h6>
        </div>
      </Container>
    )
}
const CalculaInteresesOrdinario = (props) => {
  let [fechaOrdUlt,setFechaOrdUlt] = useState(new Date().yyyymmdd('-'));
  let [fechaOrdProx,setFechaOrdProx] = useState(new Date().yyyymmdd('-'));
  let [diasOrd, setDiasOrd] = useState(0);
  let [tasaOrd, setTasaOrd] = useState(36);
  let [saldoInsoluto, setSaldoInsoluto] = useState(18534.47);
  let [intOrdAnual, setIntOrdAnual] = useState(0);
  let [intOrdDiario, setIntOrdDiario] = useState(0);
  let [intOrd, setIntOrd] = useState(0);
  let [ivaOrd, setIvaOrd] = useState(0);
  let [totOrd, setTotOrd] = useState(0);

  let [fechaMorUlt,setFechaMorUlt] = useState(new Date().yyyymmdd('-'));
  let [fechaMorProx,setFechaMorProx] = useState(new Date().yyyymmdd('-'));
  let [diasMor, setDiasMor] = useState(0);
  let [tasaMor, setTasaMor] = useState(54);
  let [capital, setCapital] = useState(1400.58);
  let [intMorAnual, setIntMorAnual] = useState(0);
  let [intMorDiario, setIntMorDiario] = useState(0);
  let [intMor, setIntMor] = useState(0);
  let [ivaMor, setIvaMor] = useState(0);
  let [totMor, setTotMor] = useState(0);

  let [total, setTotal] = useState(0);

  useEffect(() => {
    let milisegs = new Date(fechaOrdProx) - new Date(fechaOrdUlt);
    let d = Math.ceil(milisegs / (1000 * 3600 * 24));
    let intOrdA = saldoInsoluto * tasaOrd / 100;
    let intOrdD = intOrdA / 360;
    let intOrdX = intOrdD * d; 
    let iva = intOrdX * 0.16;
    let tot = intOrdX + iva + totMor + capital;
    setDiasOrd(d);
    setIntOrdAnual(intOrdA);
    setIntOrdDiario(intOrdD);
    setIntOrd(intOrdX);
    setIvaOrd(iva);
    setTotOrd(intOrdX + iva);
    setTotal(tot);
    props.actualiza(props.indice, tot)
  }, [fechaOrdUlt, fechaOrdProx]);

  useEffect(() => {
    let milisegs = new Date(fechaMorProx) - new Date(fechaMorUlt);
    let d = Math.ceil(milisegs / (1000 * 3600 * 24));
    let intOrdA = capital * tasaMor / 100;
    let intOrdD = intOrdA / 360;
    let intOrdX = intOrdD * d; 
    let iva = intOrdX * 0.16;
    let tot = intOrdX + iva + totOrd + capital;
    setDiasMor(d);
    setIntMorAnual(intOrdA);
    setIntMorDiario(intOrdD);
    setIntMor(intOrdX);
    setIvaMor(iva);
    setTotMor(intOrdX + iva);
    setTotal(tot);
    props.actualiza(props.indice, tot)
  }, [fechaMorUlt, fechaMorProx]);

  return (
    <Card>
      <CardHeader>
        <b>{props.mes}</b>
      </CardHeader>
      <CardBody>
        <CardTitle tag="h5">
          Ordinarios
        </CardTitle>
        <CardText>
          <div className='row'>
            <div className='col-3'>
              <span>Ultimo pago</span>
              <Input size="sm" type="date" value={fechaOrdUlt} onChange={(e)=> setFechaOrdUlt(e.target.value)} />
            </div>
            <div className='col-3'>
              <span>Proximo pago</span>
              <Input size="sm" type="date" value={fechaOrdProx} onChange={(e)=> setFechaOrdProx(e.target.value)}/>
            </div>
            <div className='col-2'>
              <span>Dias</span>
              <Input size="sm" value={diasOrd}/>
            </div>
            <div className='col-1'>
              <span>% Int.</span>
              <Input size="sm" value={tasaOrd}/>
            </div>
            <div className='col-2'>
              <span>Saldo Insoluto</span>
              <Input size="sm" value={saldoInsoluto.toFixed(2)}/>
            </div>
          </div>
          <div className='row'>
            <div className='col-2'>
              <span>Int. Anual</span>
              <Input size="sm" value={intOrdAnual.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>Int. Diario</span>
              <Input size="sm" value={intOrdDiario.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>Int. Generado</span>
              <Input size="sm" value={intOrd.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>16% I.V.A.</span>
              <Input size="sm" value={ivaOrd.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>Total Ordinario</span>
              <Input size="sm" disabled value={totOrd.toFixed(2)}/>
            </div>
          </div>
        </CardText>
      </CardBody>
      <CardFooter>
        <CardTitle tag="h5">
          Moratorios
        </CardTitle>
        <CardText>
          <div className='row'>
            <div className='col-3'>
              <span>Ultimo pago</span>
              <Input size="sm" type="date" value={fechaMorUlt} onChange={(e)=> setFechaMorUlt(e.target.value)} />
            </div>
            <div className='col-3'>
              <span>Proximo pago</span>
              <Input size="sm" type="date" value={fechaMorProx} onChange={(e)=> setFechaMorProx(e.target.value)}/>
            </div>
            <div className='col-2'>
              <span>Dias</span>
              <Input size="sm" value={diasMor}/>
            </div>
            <div className='col-1'>
              <span>% Int.</span>
              <Input size="sm" value={tasaMor}/>
            </div>
            <div className='col-2'>
              <span>Capital mensual</span>
              <Input size="sm" value={capital.toFixed(2)}/>
            </div>
          </div>
          <div className='row'>
            <div className='col-2'>
              <span>Int. Anual</span>
              <Input size="sm" value={intMorAnual.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>Int. Diario</span>
              <Input size="sm" value={intMorDiario.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>Int. Generado</span>
              <Input size="sm" value={intMor.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>16% I.V.A.</span>
              <Input size="sm" value={ivaMor.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>Total Moratorio</span>
              <Input size="sm" disabled value={totMor.toFixed(2)}/>
            </div>
            <div className='col-2'>
              <span>Total</span>
              <Input size="sm" disabled value={total.toFixed(2)}/>
            </div>
          </div>
        </CardText>
      </CardFooter>
    </Card>
  )
}